import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { z } from 'zod'
import { LoginPage } from '../features/auth/login-page'
import { safeRedirect, sessionQueryOptions } from '../features/auth/session'

const loginSearchSchema = z.object({
  /** Where to go after signing in (a same-origin path; validated again before use). */
  redirect: z.string().max(2000).optional().catch(undefined),
})

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context, search }) => {
    // Already signed in (valid cookie): skip the form. Always ask the server — a cached session may
    // be the very one that just expired and sent the user here.
    const session = await context.queryClient
      .fetchQuery({ ...sessionQueryOptions, staleTime: 0 })
      .catch(() => null)
    if (session) throw redirect({ href: safeRedirect(search.redirect), replace: true })
  },
  component: LoginRoute,
})

function LoginRoute() {
  const router = useRouter()
  const { redirect: target } = Route.useSearch()
  return <LoginPage onSignedIn={() => router.navigate({ href: safeRedirect(target), replace: true })} />
}
